export default {
  getByProject: (state) => (projectId) =>
    state.items.filter((_i) => _i.project === projectId),
}
